import React, { ReactNode, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/useStore";
import { useClassStore } from "store/useClassStore";
import { useProgramStore } from "store/useProgramStore";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const { user, token, logout } = useAuth();
  const { fetchClasses, classes } = useClassStore();
  const { fetchPrograms, programs } = useProgramStore();

  function setActivityTimestamp() {
    localStorage.setItem('lastActivity', Date.now().toString());
  }
  
  document.addEventListener('click', setActivityTimestamp);
  document.addEventListener('keydown', setActivityTimestamp);
  document.addEventListener('mousemove', setActivityTimestamp);
  
  function checkActivity() {
    const lastActivity = localStorage.getItem('lastActivity');
    if (lastActivity) {
        const currentTime = Date.now();
        const elapsed = currentTime - parseInt(lastActivity);
  
        const maxInactiveTime = 15 * 60 * 1000; // 15 minutes in milliseconds
        if (elapsed > maxInactiveTime) {
            logout(); // Use Zustand logout instead of clearing localStorage
            console.log('User logged out due to inactivity.');
        }
    }
  }
  
  // Check every minute
  setInterval(checkActivity, 60 * 1000);
  
  document.addEventListener('DOMContentLoaded', () => {
    setActivityTimestamp(); // Set initial timestamp
    checkActivity(); // Check immediately on load
  });

  // Load programs and classes when user is authenticated and data is not already loaded
  useEffect(() => {
    if (user && token && (classes.length === 0 || programs.length === 0)) {
      const loadData = async () => {
        try {
          
          console.log('Programs and classes loaded on app initialization');
        } catch (error) {
          console.error('Error loading programs and classes on initialization:', error);
        }
      };
      
      loadData();
    }
  }, [user, token, classes.length, programs.length]);

  //if (!user || !token) {
    if (!user) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
